import React from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

import { useApi } from "../../../hooks/useApi";

const JobRequestCancelForm = ({ job, onSuccess, onCancel }) => {
  const { call, isLoading } = useApi({
    onError: (err) => toast.error(err.message),
  });

  const cancelJob = () => {
    call(
      `/admin/job-requests/${job._id}/cancel`,
      "put",
      undefined,
      undefined,
      () => {
        onSuccess();
      }
    );
  };

  return (
    <div className="d-flex justify-content-start align-items-center gap-2">
      <Button
        variant="outline-danger"
        onClick={() => cancelJob()}
        disabled={isLoading}
      >
        Cancel Job
      </Button>
      <Button variant="link" onClick={() => onCancel()} disabled={isLoading}>
        Cancel
      </Button>
    </div>
  );
};

export default JobRequestCancelForm;
